import { render, staticRenderFns } from "./rightsDetail.vue?vue&type=template&id=f8cacbd2&scoped=true"
import script from "./rightsDetail.vue?vue&type=script&lang=js"
export * from "./rightsDetail.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=f8cacbd2&prod&scoped=true&lang=css&external"
import style1 from "./rightsDetail.vue?vue&type=style&index=1&id=f8cacbd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cacbd2",
  null
  
)

export default component.exports